<template>
  <div class="single-country">
    <section class="single-country__main" style="min-height: 600px">
      <div class="country-print-wrap hide-for-print" v-if="countryData">

        <div class="country-print" v-if="this.firstCountry && this.firstCountry.id">
          <form :action="downloadUrl" target="_blank" method="post">
            <input type="hidden" name="args" :value="downloadAttr">
            <label style="cursor: pointer">
              <DownloadIcon :size="15"></DownloadIcon>
            	<input type="submit" value="Download PDF" style="display:none">
            </label>
          </form>
        </div>

        <div class="country-print" @click="printImage()">
          <PrintIcon :size="15"></PrintIcon>
        </div>

        <ShareIcon class="country-print" v-if="firstCountry && firstCountry.name" :country="firstCountry.name" :size="15"></ShareIcon>
      </div>

      <transition name="slide">
        <div v-if="!countryData && firstCountry && $store.state.fetching.length === 0">
          <p class="mb-40 pb-20 pt-20 bg--gray-lighter pl-20 pr-20 mt-40">
            <em>For COVID-19 information, <a :href="maplink" class="color--gray-darkest">click here</a></em>
          </p>
        </div>
      </transition>


      <transition name="fade">
        <div v-if="countryData">
          <HighMediumLowExplainer v-if="$store.state.rsc.countriesCovidProfileOnly.indexOf(parseInt(firstCountry.id)) === -1" class="explainer mt-40 mb-20" :bg="true"></HighMediumLowExplainer>
          <FrameworkWheel v-if="$store.state.rsc.countriesCovidProfileOnly.indexOf(parseInt(firstCountry.id)) === -1" class="mb-40 pt-40" :dataset="currentCountryDataset()" />

          <div class="profiletable mt-20" v-if="countryData['regime_type'] || countryData['state_of_emergency'] || countryData['summary']">
            <div class="profiletable__row flex w-full" v-if="countryData['regime_type'] && countryData['regime_type'] !== ''">
              <div class="profiletable__row__data flex-none w-150 bg--gray-200 text-bold">Regime Type</div>
              <div class="profiletable__row__data flex-auto w-full bg--gray-200" v-html="countryData['regime_type']">
                <span v-html="countryData['regime_type']"></span>
              </div>
            </div>
            <div class="profiletable__row flex w-full" v-if="countryData['state_of_emergency'] && countryData['state_of_emergency'] !== ''">
              <div class="profiletable__row__data flex-none w-150 bg--gray-200 text-bold">State of emergency</div>
              <div class="profiletable__row__data flex-auto w-full bg--gray-200">
                <span v-html="countryData['state_of_emergency']"></span>
                <MiniSourceLink :sources="countryData['state_of_emergency_sources']"></MiniSourceLink>
              </div>
            </div>
            <div class="profiletable__row flex w-full" v-if="countryData['summary'] && countryData['summary'] !== ''">
              <div class="profiletable__row__data flex-none w-150 bg--gray-200 text-bold">COVID-19 Democracy & Human Rights Impact Summary</div>
              <div class="profiletable__row__data flex-auto w-full bg--gray-200">
                <span v-html="countryData['summary']"></span>
                <MiniSourceLink :sources="countryData['summary_sources']"></MiniSourceLink>
              </div>
            </div>
          </div>

          <div v-if="countryData && countryData.incident_reports && $store.state.rsc.countriesCovidProfileOnly.indexOf(parseInt(firstCountry.id)) === -1">
            <p class="font-small mb-10 mt-40 text-bold">GSoD Indices 2021</p>
            <HighMediumLowExplainer class="explainer mt-0 mb-40" :bg="true"></HighMediumLowExplainer>
          </div>

          <div class="profiletable mt-40" v-if="hasIncidents(['A_01', 'SA_01_01', 'SA_01_02', 'SA_01_03', 'SA_01_04'])">
            <ProfiletableAttributeHeader :dataset="currentCountryDataset()" attribute-key="A_01"></ProfiletableAttributeHeader>
            <ProfiletableHeader></ProfiletableHeader>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_01_01'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_01_01"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_01_02'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_01_02"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_01_03'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_01_03"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_01_04'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_01_04"></ProfiletableRow>
          </div>

          <div class="profiletable mt-40" v-if="hasIncidents(['A_02', 'SA_02_01', 'SA_02_02', 'SA_02_03', 'SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e', 'SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c'])">
            <ProfiletableAttributeHeader :dataset="currentCountryDataset()" attribute-key="A_02"></ProfiletableAttributeHeader>
            <ProfiletableHeader></ProfiletableHeader>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_02_01'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_02_01"></ProfiletableRow>
            <ProfiletableAttributeHeader v-if="hasIncidents(['SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e'])" :dataset="currentCountryDataset()" attribute-key="SA_02_02"></ProfiletableAttributeHeader>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SC_02_02_a'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SC_02_02_a"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SC_02_02_b'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SC_02_02_b"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SC_02_02_c'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SC_02_02_c"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SC_02_02_d'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SC_02_02_d"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SC_02_02_e'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SC_02_02_e"></ProfiletableRow>
            <ProfiletableAttributeHeader v-if="hasIncidents(['SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c'])" :dataset="currentCountryDataset()" attribute-key="SA_02_03"></ProfiletableAttributeHeader>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SC_02_03_a'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SC_02_03_a"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SC_02_03_b'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SC_02_03_b"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SC_02_03_c'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SC_02_03_c"></ProfiletableRow>
          </div>

          <div class="profiletable mt-40" v-if="hasIncidents(['A_03', 'SA_03_01', 'SA_03_02', 'SA_03_03'])">
            <ProfiletableAttributeHeader :dataset="currentCountryDataset()" attribute-key="A_03"></ProfiletableAttributeHeader>
            <ProfiletableHeader></ProfiletableHeader>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_03_01'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_03_01"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_03_02'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_03_02"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_03_03'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_03_03"></ProfiletableRow>
          </div>

          <div class="profiletable mt-40" v-if="hasIncidents(['A_04', 'SA_04_01', 'SA_04_02'])">
            <ProfiletableAttributeHeader :dataset="currentCountryDataset()" attribute-key="A_04"></ProfiletableAttributeHeader>
            <ProfiletableHeader></ProfiletableHeader>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_04_01'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_04_01"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_04_02'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_04_02"></ProfiletableRow>
          </div>

          <div class="profiletable mt-40" v-if="hasIncidents(['A_05', 'SA_05_01', 'SA_05_02', 'SA_05_03', 'SA_05_04'])">
            <ProfiletableAttributeHeader :dataset="currentCountryDataset()" attribute-key="A_05"></ProfiletableAttributeHeader>
            <ProfiletableHeader></ProfiletableHeader>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_05_01'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_05_01"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_05_02'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_05_02"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_05_03'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_05_03"></ProfiletableRow>
            <ProfiletableRow :country="firstCountry" v-if="hasIncidents(['SA_05_04'])" :covid19dataset="countryData" :dataset="currentCountryDataset()" attribute-key="SA_05_04"></ProfiletableRow>
          </div>

          <div class="profiletable mt-20 pt-40 mb-20" v-if="countryData && countryData.additional_information">
            <div class="profiletable__row flex w-full">
              <div class="profiletable__row__data flex-none w-full bg--gray-lightest flex items-center text-bold">
                Additional information
              </div>
            </div>
            <div class="profiletable__row flex w-full">
              <div class="profiletable__row__data flex-none w-full bg--gray-200 pb-40 pt-40 pl-60 pr-60">
                <span v-html="countryData['additional_information']"></span>
                <MiniSourceLink :sources="countryData['additional_information_sources']"></MiniSourceLink>
              </div>
            </div>
          </div>

          <div class="profiletable mt-20 pt-40 mb-20" v-if="countryData.democratic_violations_inde || countryData.pandemic_backsliding_index">
            <div class="profiletable__row flex w-full">
              <div class="profiletable__row__data flex-none w-150 bg--gray-lightest flex justify-center items-center">
                <a class="block" href="https://www.v-dem.net/en/analysis/PanDem/" target="_blank"><img :src="VDemLogo" class="img-responsive w-full" alt="V-Dem Institute"></a>
              </div>
              <div class="profiletable__row__data flex-auto w-full profiletable__row__data--no-padding">
                <div class="profiletable__row flex w-full" v-if="countryData.democratic_violations_inde">
                  <div class="profiletable__row__data flex-none w-150 bg--gray-lightest text-bold">
                    {{ $Strings('vdem_pandem') }}
                  </div>
                  <div class="profiletable__row__data bg--gray-200 flex-auto w-full">
                    {{ countryData.democratic_violations_inde }}
                  </div>
                </div>
                <div class="profiletable__row flex w-full" v-if="countryData.pandemic_backsliding_index">
                  <div class="profiletable__row__data flex-none w-150 bg--gray-lightest text-bold">
                    {{ $Strings('vdem_panback') }}
                  </div>
                  <div class="profiletable__row__data bg--gray-200 flex-auto w-full">
                    {{ countryData.pandemic_backsliding_index }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <div v-if="firstCountry && $store.state.rsc.countriesCovidProfileOnly.indexOf(parseInt(firstCountry.id)) === -1">
        <div v-if="countryData" class="main-attribute-charts">
          <div class="main-attribute-charts__item" v-bind:key="key" v-for="key in ['A_01', 'A_02', 'A_03', 'A_04']">
            <!-- <DevelopmentsToWatch
              class="main-attribute-charts__item__icon"
              v-if="firstCountry && firstCountry.id && $store.getters['covid19/countryAttributeType'](firstCountry.id, key) === 'watch'"
              :size="30"
            ></DevelopmentsToWatch>

            <ConcerningDevelopments
            class="main-attribute-charts__item__icon"
              v-if="firstCountry && firstCountry.id && $store.getters['covid19/countryAttributeType'](firstCountry.id, key) === 'high'"
              :size="30"
            ></ConcerningDevelopments> -->
            <CircleChart class="main-attribute-charts__item__svg" :value="getAttributeValue(key, 'value')" :color="getAttributeValue(key, 'value') | valueColor"></CircleChart>
            <div class="main-attribute-charts__item__label">{{ getAttributeValue(key, 'label') }}<br />
              <HelpTooltip class="mt5" v-if="getAttributeValue(key, 'description')" :description="getAttributeValue(key, 'description')"></HelpTooltip>
            </div>
          </div>
          <div class="main-attribute-charts__item">
            <div class="main-attribute-charts__item__svg">&nbsp;</div>
            <div v-if="getAttributeValue('A_01', 'value')" class="main-attribute-charts__item__label">{{ this.$Strings('popularParticipation') }}</div>
            <div v-else class="main-attribute-charts__item__label">{{ this.$Strings('popularParticipation') }}</div>
            <HelpTooltip v-if="getAttributeValue('A_01', 'description')" :description="this.$Strings('popularParticipationTooltip')"></HelpTooltip>
          </div>
        </div>

        <div v-if="countryData" class="actions--bar flex justify-end mb-10">
          <div class="confidence-actions">
            <Checkbox
              :reverse="true"
              class="confidence-actions__checkbox"
              :active="$store.state.confidenceIntervals"
              @toggle="$store.state.confidenceIntervals = !$store.state.confidenceIntervals"
            >{{ this.$Strings('confidenceIntervals') }}</Checkbox>
            <HelpTooltip class="confidence-actions__tooltip" :description="this.$Strings('confidenceIntervalsDescription')"></HelpTooltip>
          </div>
          <div class="confidence-actions" v-if="firstCountry && firstCountry.id !== '999'">
            <Checkbox
              :reverse="true"
              class="confidence-actions__checkbox"
              :active="$store.state.isWorldAverageEnabled"
              @toggle="$store.state.isWorldAverageEnabled = !$store.state.isWorldAverageEnabled"
            >{{ this.$Strings('worldAverageCheckbox') }}</Checkbox>
            <HelpTooltip class="confidence-actions__tooltip" :description="this.$Strings('worldAverageCheckboxDescription')"></HelpTooltip>
          </div>
        </div>

        <HighMediumLowExplainer  v-if="countryData && subattributeData[0] && subcomponentData[0]" class="explainer mb-10" :bg="true"></HighMediumLowExplainer>
        <div class="barchart" v-if="countryData && subattributeData[0] && subcomponentData[0]">
          <div class="barchart__wrap--dark">
            <div
              class="barchart__line"
              v-for="(row, i) in subattributeData[0]"
              :key="'country_' + i"
            >
              <BarLine
                :annotation-value="$store.state.isWorldAverageEnabled && firstCountry && firstCountry.id !== '999' ? getWorldDataValue(row.columnKey) : undefined"
                :confInt="row.range"
                :color="row.value | valueColor"
                :value="parseFloat(row.value)"
                :tooltip="row.description"
                :label="row.label"
                :showValues="true"
                :showRange="$store.state.confidenceIntervals"
                :mini="true"
              ></BarLine>

              <DevelopmentsToWatch
                class="barchart__line__icon"
                v-if="firstCountry && firstCountry.id && $store.getters['covid19/countryAttributeType'](firstCountry.id, row.columnKey) === 'watch'"
                :size="30"
              ></DevelopmentsToWatch>

              <ConcerningDevelopments
              class="barchart__line__icon"
                v-if="firstCountry && firstCountry.id && $store.getters['covid19/countryAttributeType'](firstCountry.id, row.columnKey) === 'high'"
                :size="30"
              ></ConcerningDevelopments>
            </div>
          </div>

          <div class="barchart__wrap--light">
            <div
              class="barchart__line"
              v-for="(row, i) in subcomponentData[0]"
              :key="'sub_country_' + i"
            >
              <BarLine
                :annotation-value="$store.state.isWorldAverageEnabled && firstCountry && firstCountry.id !== '999' ? getWorldDataValue(row.columnKey) : undefined"
                :confInt="row.range"
                :color="row.value | valueColor"
                :value="parseFloat(row.value)"
                :tooltip="row.description"
                :label="row.label"
                :showValues="true"
                :showRange="$store.state.confidenceIntervals"
                :mini="true"
              ></BarLine>

              <DevelopmentsToWatch
                class="barchart__line__icon"
                v-if="firstCountry && firstCountry.id && $store.getters['covid19/countryAttributeType'](firstCountry.id, row.columnKey) === 'watch'"
                :size="30"
              ></DevelopmentsToWatch>

              <ConcerningDevelopments
              class="barchart__line__icon"
                v-if="firstCountry && firstCountry.id && $store.getters['covid19/countryAttributeType'](firstCountry.id, row.columnKey) === 'high'"
                :size="30"
              ></ConcerningDevelopments>
            </div>
          </div>
        </div>
      </div>

      <SourceLinksSection v-if="countryData && countryData['source_links']" :sourceLinks="countryData['source_links']"></SourceLinksSection>

      <div class="profiletable mt-20 pt-40 mb-20" v-if="countryData && countryData.incident_reports">
        <div class="profiletable__row flex w-full">
          <div class="profiletable__row__data flex-none w-full bg--gray-lightest flex items-center text-bold">
            Disclaimer
          </div>
        </div>
        <div class="profiletable__row flex w-full">
          <div class="profiletable__row__data flex-none w-full bg--gray-200 pb-40 pt-40 pl-60 pr-60" v-html="this.$Strings('covid19_disclaimer')"></div>
        </div>
      </div>

      <a ref="downloadLink"></a>

    </section>
    <!-- /.single-country__main -->
  </div>
</template>


<script>
import _ from 'lodash'
import axios from 'axios'

import BarLine from './../shared/charts/BarLine.vue'
import Checkbox from './../shared/misc/Checkbox.vue'
import CircleChart from './../shared/charts/CircleChart.vue'
import FrameworkWheel from './../shared/charts/FrameworkWheel.vue'
import HelpTooltip from './../shared/misc/HelpTooltip.vue'
import HighMediumLowExplainer from './../shared/misc/HighMediumLowExplainer.vue'
import ProfiletableRow from './ProfiletableRow.vue'
import ProfiletableHeader from './ProfiletableHeader.vue'
import ProfiletableAttributeHeader from './ProfiletableAttributeHeader.vue'
import SourceLinksSection from './SourceLinksSection.vue'
import DevelopmentsToWatch from './../shared/icons/DevelopmentsToWatch.vue'
import ConcerningDevelopments from './../shared/icons/ConcerningDevelopments.vue'
import AttributeIcon from './../shared/icons/AttributeIcon.vue'
import PrintIcon from './../shared/icons/PrintIcon.vue'
import ShareIcon from './../shared/icons/ShareIcon.vue'
import DownloadIcon from './../shared/icons/DownloadIcon.vue'
import {EventBus} from '@/event-bus.js'
import MiniSourceLink from './MiniSourceLink.vue'

export default {
  name: 'covid19-profile',
  components: {
    AttributeIcon,
    ConcerningDevelopments,
    DevelopmentsToWatch,
    SourceLinksSection,
    ProfiletableAttributeHeader,
    ProfiletableHeader,
    ProfiletableRow,
    BarLine,
    Checkbox,
    CircleChart,
    FrameworkWheel,
    PrintIcon,
    DownloadIcon,
    ShareIcon,
    HelpTooltip,
    HighMediumLowExplainer,
    MiniSourceLink
  },
  props: [ 'currentCountryDataset', 'firstCountry', 'subattributeData', 'subcomponentData', 'worldData' ],
  data () {
    return {
      CancelToken: axios.CancelToken,
      countryData: false,
      sourcelinkNum: 0
    }
  },
  metaInfo () {
    let title = 'The Global State of Democracy initiative'
    if (this.firstCountry && this.firstCountry.name) {
      title += ' ' + this.firstCountry.name
    }
    return {
      title: title,
      meta: [
        { name: 'description', content: 'Global Monitor of COVID-19´s impact on Democracy and Human Rights.' },
        { property: 'og:title', content: title },
        { property: 'og:site_name', content: 'The Global State of Democracy initiative' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: this.profileUrl },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  computed: {
    profileUrl () {
      if (this.firstCountry && this.firstCountry.name) {
        return process.env.APP_URL +
          'profile/' +
          (this.$store.state.covid19.is_enabled ? 'covid19/' : '') +
          this.firstCountry.name.toLowerCase().replace(/[^a-zA-Z0-9._-]+/g, '-')
      }
      return ''
    },
    maplink () {
      return process.env.APP_URL + '#/indices/world-map?covid19=1'
    },
    VDemLogo () {
      return process.env.APP_URL + 'themes/custom/gsodi/img/vdem-logo.png'
    },
    downloadUrl () {
      return process.env.APP_URL + 'gsodi-pdf/download'
    },
    downloadAttr () {
      return 'rsc=[' + this.firstCountry.id + ']&covid19=1'
    }
  },
  mounted () {
    this.fetchCountryInfo()
  },
  destroyed () {
    this.$store.state.covid19.last_updated = false
  },
  watch: {
    'firstCountry' () {
      this.countryData = false
      this.fetchCountryInfo()
    },
    'countryData' () {
      this.$store.state.covid19.last_updated = this.countryData['last_updated']
    }
  },
  methods: {
    fetchCountryInfo () {
      if (!this.firstCountry || !this.firstCountry.id) {
        return false
      }

      this.$store.dispatch('startFetching', 'covid19profile')
      axios.get(process.env.COVID19_API_URL + 'covid19/country/' + this.firstCountry.id + '?t=' + this.apiRefreshToken(), {
        cancelToken: new this.CancelToken((c) => {
          this.cancel = c
        })
      })
        .then((response) => {
          this.$store.dispatch('stopFetching', 'covid19profile')
          if (response.data.country_code) {
            this.countryData = response.data
          }
        })
        .catch((error) => {
          this.$store.dispatch('stopFetching', 'covid19profile')
          if (!axios.isCancel(error)) {
            EventBus.$emit('popup.open', this.$Strings('json_error_title'), this.$Strings('json_error_body'))
            console.log(error)
          }
        })
    },

    printImage () {
      window.print()
    },

    getEmptyRowData (countryname, columnKey) {
      let rowData = { range: [] }
      rowData.columnKey = false
      rowData.range[0] = false
      rowData.range[1] = false
      rowData.value = false
      rowData.country = countryname
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name')
      rowData.color = 'gray-lighter'
      rowData.description = false
      return rowData
    },

    getRowData (row, columnKey) {
      let rowData = { range: [] }
      rowData.columnKey = columnKey
      rowData.range[0] = row[columnKey + '_L'] ? row[columnKey + '_L'] : false
      rowData.range[1] = row[columnKey + '_U'] ? row[columnKey + '_U'] : false
      rowData.value = row[columnKey] || false
      rowData.country = row['ID_country_name']
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name')
      rowData.color = this.$store.getters['attributes/labelInfo'](columnKey, 'color')
      rowData.description = this.$store.getters['attributes/labelInfo'](columnKey, 'description')
      return rowData
    },

    getAttributeValue (columnKey, value) {
      let row = this.currentCountryDataset()
      let data = !row ? this.getEmptyRowData('', columnKey) : this.getRowData(row, columnKey)
      return data[value] ? data[value] : undefined
    },

    getWorldDataValue (columnKey) {
      let worldrow = this.worldData
      if (!columnKey || !worldrow) return undefined
      let result = this.getRowData(worldrow, columnKey)
      return (result && result.value) ? parseFloat(result.value) : undefined
    },

    hasIncidents (columnKeys) {
      let result = false

      if (!this.countryData.incident_reports) {
        return result
      }

      _.each(columnKeys, (key) => {
        _.each(this.countryData.incident_reports, (incident) => {
          if (incident.attribute_code === key) {
            result = true
          }
        })
      })

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/mixins/clearfix';
  @import '~@/components/sass/mixins/flexbox-grid';
  @import '~@/components/sass/components/btns';
  @import '~@/components/sass/shared/helpers';

  .country-print-wrap {
    position: absolute;
    top: -40px;
    right: 0;
  }

  .country-print {
    background: $gray-lightest;
    border-radius: 100%;
    color: $gray-darkest;
    cursor: pointer;
    display: inline-block;
    height: 40px;
    padding: 12px;
    transition: all .25s ease;
    width: 40px;

    &:hover {
      background: $gray-darkest;
      color: $white;
    }
  }

  .confidence-actions{
    display: flex; -js-display: flex;
    justify-content: flex-end;
    text-align: right;
  }

  // .confidence-actions__checkbox{}
  .confidence-actions__tooltip{
    margin: 1px 13px 0 5px
  }

  .single-country{
    display: flex; -js-display: flex;
    justify-content: space-between;
  }

  .single-country__main{
    flex: 1 1 655px;
    max-width: 100%;
    position: relative;
  }
  .single-country__sidebar{
    flex: 0 0 300px;
    max-width: 300px;
    padding-left: 40px;

    @media (max-width: 1100px) {
      flex: 0 0 260px;
      max-width: 260px;
      padding-left: 20px;
    }
  }

  .main-attribute-charts{
    @include grid($gutter: 20px)
    margin-top: 80px;
  }

  .main-attribute-charts__item{
    flex: 1 1 calc(20% - 20px);
    padding: 0 10px 20px;
    position: relative;
    text-align: center;
    width: calc(20% - 20px);

    &__icon {
      position: absolute;
      top: -20px;
      left: 50%;
      margin-left: -15px;
      z-index: 1;
    }
  }

  .main-attribute-charts__item__svg{
    display: block;
    height: 40px;
    margin: 0 auto;
    width: 40px
  }

  .main-attribute-charts__item__label{
    font-size: 12px;
    line-height: 1.2em;
    margin-top: 10px;

    @media (max-width: 1100px) {
      font-size: 10px;
    }
  }


  .linechart_svg{
    .cls-1{fill: none;}
    .cls-2{clip-path: url(#clip-path);}
    .cls-3{fill: $gray-lighter;}
    .cls-4{opacity: 0.15;}
    .cls-5{fill: $gray;}
    .cls-6{fill: $gray-darkest;}
  }

  .infoOverlay {
    max-width: 715px;
  }
  .single-country .infoOverlay{
    left: -20px;
    right: -20px;
  }

  .mt5{ margin-top: 5px }

  .barchart{
    display: flex; -js-display: flex;
    justify-content: space-between;
  }

  .barchart__wrap,
  .barchart__wrap--light,
  .barchart__wrap--dark {
    display: flex; -js-display: flex;
    flex: 1 1 auto;
    justify-content: space-between;
    padding: 20px 10px;
  }

  .barchart__wrap--dark {
    background: $gray-lightest;
  }

  .barchart__wrap--light {
    background: $gray-200;
  }

  .barchart__line{
    flex: 1 1 auto;
    position: relative;
  }

  .barchart__line__icon {
    position: absolute;
    top: -15px;
    left: 50%;
    margin-left: -15px;
  }

</style>



// WEBPACK FOOTER //
// src/components/covid19/Covid19Profile.vue